import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Table from '@common/Table'
import { toJS } from 'mobx'
import columns from './column'
import store from '../store'

@observer
export default class extends Component {
  componentDidMount() {
    store.getList()
  }
  render() {
    const {
      data,
      set_meal,
      activity_position,
      //isSelected,
      pagination,
      paging,
      can_show_tip
    } = store
    let rowSelection = {
      // 1.已选过的套餐不可选; 2.旧套餐不可选； 3，超过最大套餐提交数，列表套餐不可选
      selectedRowKeys: store.$selectedRowKeys,
      onChange: store.$onSelectChange,
      hideDefaultSelections: true,
      getCheckboxProps: record => {
        return {
          disabled:
            set_meal.some(item => item.set_meal_id == record.id) ||
            record.version != '1'
          //|| (isSelected && !store.$selectedRowKeys.includes(record.id))
        }
      }
    }

    return (
      <Table
        selectabled
        store={store}
        columns={columns(activity_position, set_meal, can_show_tip)}
        shouldGetListWhenDidMount={false}
        bordered={false}
        dataSource={toJS(data)}
        pagination={pagination}
        onChange={paging}
        rowSelection={rowSelection}
        style={{ padding: '20px' }}
      />
    )
  }
}
